module.exports = __webpack_public_path__ + "img/us.2b922c28.svg";